import {
  IsNotEmpty,
  IsIn,
  IsOptional,
  IsNumber,
  IsArray,
  IsBoolean,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IHerdingScore } from "./herding-score.interface";
import { HerdingElementDeductionDto } from "./herding-element-deduction.dto";

export class HerdingScoreDto implements IHerdingScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  score?: number;

  started_at: string;

  finished_at: string;

  @IsNumber()
  elapsed_time: number; // seconds

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => HerdingElementDeductionDto)
  element_deductions?: HerdingElementDeductionDto[];

  @IsOptional()
  @IsBoolean()
  total_deductions_only?: boolean;

  @IsOptional()
  @IsNumber()
  deducted_points?: number;

  @IsOptional()
  @IsNumber()
  misbehaviour_points?: number;

  @IsOptional()
  @IsNumber()
  total_points_deducted?: number;

  @IsOptional()
  comments?: string;
}
